import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { openCustomModal, closeCustomModal } from "views/lib/components/modals";
import { getList } from "actions/scooter/zones/actions";
import ScooterZonesMap from "./map";

const googleMapURL = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization";

const ScooterTripActive = ({
                             list,
                             getList,
                           }) => {
  useEffect(() => {
    getList();
  }, [getList]);

  return (
    <div className="w-100 p-2">
      <ScooterZonesMap
        places={list}
        googleMapURL={googleMapURL}
        loadingElement={<div style={{ height: "100%" }}/>}
        containerElement={<div style={{ height: "calc(100vh - 70px)" }}/>}
        mapElement={<div style={{ height: "100%" }}/>}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  list: state.scooterZones.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ScooterTripActive);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/zones/index.js